import { render, staticRenderFns, recyclableRender, components } from "./u-divider.vue?vue&type=template&id=239d3faa&scoped=true&"
var renderjs
import script from "./u-divider.vue?vue&type=script&lang=js&"
export * from "./u-divider.vue?vue&type=script&lang=js&"
import style0 from "./u-divider.vue?vue&type=style&index=0&id=239d3faa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239d3faa",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-divider/u-divider.vue"
export default component.exports